// Administração > Conta & Integrações > Planos. Backend próprio
// (2026-08-28), mesma permissão granular de Integrações/Contrato
// (administracao.conta_integracoes). Fonte real de preço usada ao montar
// uma Recorrência (aba FATURAMENTO, ver users.tsx) — antes disso o valor
// de cada veículo era digitado à mão sem nenhuma tabela de preços.
import { gpsDriveDelete, gpsDriveGet, gpsDrivePost, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface Plan {
  id: string;
  name: string;
  description: string | null;
  value: number;
  // Grupo de assistência incluído no plano (pedido 2026-09-11), ex.:
  // plano "Ouro" → grupo "Assistência 100km". null = plano sem assistência.
  serviceGroupId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertPlanInput {
  name: string;
  description?: string | null;
  value: number;
  serviceGroupId?: string | null;
}

export const gpsDrivePlansService = {
  list: () => gpsDriveGet<Plan[]>("/api/v1/admin/plans"),
  create: (input: UpsertPlanInput) => gpsDrivePost<Plan>("/api/v1/admin/plans", input),
  update: (id: string, input: UpsertPlanInput) => gpsDrivePut<Plan>(`/api/v1/admin/plans/${id}`, input),
  remove: (id: string) => gpsDriveDelete<void>(`/api/v1/admin/plans/${id}`),
};
